import React, { useRef, useEffect, useState } from 'react';
import { usePlacesAutocomplete } from '../usePlacesAutocomplete';  // 引入自定義 Hook
import style from "./PlacesInput.module.scss";
import * as YStyled from '../../../Styleds';
import styled from 'styled-components';

const App = styled.div`
  height: ${({ height }) => (height === 0 ? 'auto' : `${height}px`)};
`;

const PlacesInput = ({ type = 0, onSelect, initKeyWord, ...props }) => {
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);
  const [inProp, setInProp] = useState(true);
  const [disabled, set_disabled] = useState(false);
  const [inputHeight, set_inputHeight] = useState(0);
  const [keyword, set_keyword] = useState("");
  const [keyword2, set_keyword2] = useState("");

  // 使用自定義的 usePlacesAutocomplete Hook
  const { predictions, searchPredictions, getPlaceDetails,searchNearby } = usePlacesAutocomplete();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if(inputRef.current)
    set_inputHeight(inputRef.current.clientHeight);
  }, [inputRef.current]);

  useEffect(() => {
    if (keyword.length >= 3 && keyword2 !== keyword) {
      searchPredictions(keyword);
      set_keyword2("");
    } else {
      setInProp(false);
    }
  }, [keyword, searchPredictions]);

  useEffect(() => {
    setInProp(predictions.length > 0);
  }, [predictions]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setInProp(false);
    }
  };

  if (type === 0) {
    return (
      <App className={style.app} height={inputHeight} ref={dropdownRef}>
        <div className={style.inputBox}>
          <YStyled.Input
            style={{ borderWidth: "0px" }}
            {...props}
            size={17}
            value={keyword}
            disabled={disabled}
            ref={inputRef}
            onClick={() => searchPredictions(keyword)}
            onChange={e => set_keyword(e.target.value)}
          />
        </div>
        {inProp && (
          <div className={style.modal}>
            {predictions.map((v, k) => (
              <span key={k} onClick={() => {
                set_keyword(v.description);
                set_keyword2(v.description);
                setInProp(false);
                getPlaceDetails(v.place_id, onSelect);
              }}>
                {v.description}
              </span>
            ))}
          </div>
        )}
      </App>
    );
  } else if (type === 1) {
    return (
      <App className={style.app2} height={inputHeight} ref={dropdownRef}>
        <div className={style.inputBox}>
          <img src="./assets/ui/cicle.png" />
          <YStyled.Input
            {...props}
            size={17}
            value={keyword}
            disabled={disabled}
            ref={inputRef}
            onClick={() => searchPredictions(keyword)}
            onChange={e => set_keyword(e.target.value)}
          />
        </div>
        {inProp && (
          <div className={style.modal}>
            {predictions.map((v, k) => (
              <span key={k} onClick={() => {
                set_keyword(v.description);
                set_keyword2(v.description);
                setInProp(false);
                getPlaceDetails(v.place_id, onSelect);
              }}>
                {v.description}
              </span>
            ))}
          </div>
        )}
      </App>
    );
  }
  else if (type === 2) {
    return (
      <YStyled.Label style={{ justifyContent:"flex-start",background: "#F4F4F4", padding: ".4rem .8rem" }}>
         <YStyled.Span>{initKeyWord}</YStyled.Span>
      </YStyled.Label>
    );
  }
  // 其他類型邏輯可保持不變...
};

export default PlacesInput;
